import { useState } from "react";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";

export const LogoutButton = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (isLoggingOut) return;
    
    setIsLoggingOut(true);
    console.log("Starting logout process...");
    
    try {
      const { error } = await supabase.auth.signOut();
      
      if (error) {
        console.error("Logout error:", error);
        // If we get a 403 user_not_found error, clear everything
        if (error.status === 403 && error.message.includes('user_not_found')) {
          console.log("User not found, clearing all auth state");
          localStorage.clear();
          window.location.href = "/";
          return;
        }
        throw error;
      }
      
      console.log("Logout successful");
      localStorage.clear(); // Clear all local storage
      window.location.href = "/"; // Force a full page reload
      
      toast({
        title: "Logged out successfully",
        description: "You have been logged out of your account",
      });
    } catch (error) {
      console.error("Error during logout:", error);
      toast({
        title: "Error",
        description: "There was a problem logging out",
        variant: "destructive",
      });
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <Button 
      variant="outline"
      className="gradient-button-variant flex items-center gap-2 whitespace-nowrap"
      onClick={handleLogout}
      disabled={isLoggingOut}
    >
      <LogOut className="h-4 w-4" />
      <span className="hidden lg:inline">{isLoggingOut ? 'Logging out...' : 'Logout'}</span>
    </Button>
  );
};